import React, { useState, useEffect } from "react";
import { Table, Modal, Spinner, Alert, Form } from "react-bootstrap";
import GetAllSchoolInvoice from "./GetAllSchoolInvoice";
import { useSelector } from "react-redux";
import { useAlert } from "react-alert";
import { baseUrl } from "../../../../services/config";
import { Paper } from "@material-ui/core";
import { DatePicker, Space } from "antd";
import { IoMdCloseCircle } from "react-icons/io";

const { RangePicker } = DatePicker;

function GenerateInvoice() {
  const alert = useAlert();
  const [allsessions, setallsessions] = useState([]);
  const [currentsession, setcurrentsession] = useState("");

  const [invoiceData, setInvoiceData] = useState([]);
  const [invoiceLoading, setInvoiceLoading] = useState(false);
  const [preInvoiceLoading, setPreInvoiceLoading] = useState(false);
  const [invoiceModal, setInvoiceModal] = useState(false);
  const [previeweModal, setPreviewModal] = useState(false);
  const authtoken = localStorage.getItem("userToken");
  const [due_date, setdue_date] = useState(
    new Date().toISOString().split("T")[0]
  );
  const [issue_date, setissue_date] = useState(
    new Date().toISOString().split("T")[0]
  );
  const [isallfields, setisallfields] = useState(false);
  let [monthlyFeeInputsvalue, setmonthlyFeeInputsvalue] = useState([]);
  let [errorcreate, seterrorcreate] = useState("Please Fill All The Fields");
  const [selectedSchoolIDs, setSelectedSchoolIDs] = useState([]);

  useEffect(() => {
    getAllSessions();
  }, []);

  const getAllSessions = () => {
    fetch(`${baseUrl}/session`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        setallsessions(data.payload);
        data.payload.map((item, index) => {
          if (item.active_financial_year == "1") {
            setcurrentsession(item.id);
          }
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const cencelModal = () => {
    setisallfields(false);
    setInvoiceLoading(false);
    setPreInvoiceLoading(false);
    seterrorcreate("Please Fill All The Fields");
  };

  // Generate Invoice
  const previewSchoolInvoice = async () => {
    setPreInvoiceLoading(true);
    if (monthlyFeeInputsvalue.length == 0) {
      setisallfields(true);
      seterrorcreate("Please Add Monthly Fee");
      setPreInvoiceLoading(false);
      return;
    }

    if (due_date.length == 0 || issue_date.length == 0) {
      setisallfields(true);
      seterrorcreate("Please Give Due And issue Dates");
      setPreInvoiceLoading(false);
      return;
    }

    if (due_date.slice(0, 4) < "2020" || issue_date.slice(0, 4) < "2020") {
      setisallfields(true);
      seterrorcreate("Due Or issue Dates must be after 2020");
      setPreInvoiceLoading(false);
      return;
    }

    setisallfields(false);
    const data = {
      session_id: currentsession,
      school_account_ids: selectedSchoolIDs,
      months: monthlyFeeInputsvalue,
      due_date,
      issue_date,
      preview: 1,
    };

    await fetch(`${baseUrl}/invoices`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${authtoken}`,
      },
      body: JSON.stringify(data),
    })
      .then((res) =>
        res.json().then((data) => {
          setPreInvoiceLoading(false);
          if (data?.metadata?.success) {
            setInvoiceData(data?.payload);
            setPreInvoiceLoading(false);
            setisallfields(false);
            setInvoiceModal(true);
          } else if (!data.metadata.success) {
            Object.values(data.metadata.message).map((msg) => {
              alert.error(msg);
            });
            setPreviewModal(false);
            setPreInvoiceLoading(false);
          } else {
            setPreviewModal(false);
            setPreInvoiceLoading(false);
            alert.show(
              data?.metadata?.message
                ? data?.metadata?.message
                : "Something went wrong"
            );
          }
          cencelModal();
        })
      )
      .catch((err) => {
        setPreviewModal(false);
        alert.show(err);
      });
  };

  // Generate Invoice
  const generateSchoolInvoice = async () => {
    setInvoiceLoading(true);
    if (monthlyFeeInputsvalue.length == 0) {
      setisallfields(true);
      seterrorcreate("Please Add Monthly Fee");
      setInvoiceLoading(false);
      return;
    }

    if (due_date.length == 0 || issue_date.length == 0) {
      setisallfields(true);
      seterrorcreate("Please Give Due And issue Dates");
      setInvoiceLoading(false);
      return;
    }

    if (due_date.slice(0, 4) < "2020" || issue_date.slice(0, 4) < "2020") {
      setisallfields(true);
      seterrorcreate("Due Or issue Dates must be after 2020");
      setInvoiceLoading(false);
      return;
    }

    setisallfields(false);
    const data = {
      session_id: currentsession,
      school_account_ids: selectedSchoolIDs,
      months: monthlyFeeInputsvalue,
      due_date,
      issue_date,
      preview: 0,
    };

    await fetch(`${baseUrl}/invoices`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${authtoken}`,
      },
      body: JSON.stringify(data),
    })
      .then((res) =>
        res.json().then((data) => {
          setInvoiceLoading(false);
          if (data?.metadata?.success) {
            setInvoiceModal(false);
            setInvoiceLoading(false);
            setisallfields(false);
            setPreviewModal(false);
            alert.success("Invoice Generated Successfully");
          } else if (!data.metadata.success) {
            Object.values(data.metadata.message).map((msg) => {
              alert.error(msg);
            });
            setInvoiceModal(false);
            setPreviewModal(false);
            setInvoiceLoading(false);
          } else {
            setInvoiceModal(false);
            setPreviewModal(false);
            setInvoiceLoading(false);
            alert.show(
              data?.metadata?.message
                ? data?.metadata?.message
                : "Something went wrong"
            );
          }
          cencelModal();
        })
      )
      .catch((err) => {
        setPreviewModal(false);
        setInvoiceModal(false);
        alert.show(err);
      });
  };

  const getStudentArray = (value) => {
    setSelectedSchoolIDs([]);
    setSelectedSchoolIDs(value);
  };

  const handleChanger = (day, date) => {
    let startDate = date[0] + "-01";
    let endDate = date[1] + "-01";
    var start = startDate.split("-");
    var end = endDate.split("-");
    var startYear = parseInt(start[0]);
    var endYear = parseInt(end[0]);
    var dates = [];

    for (var i = startYear; i <= endYear; i++) {
      var endMonth = i != endYear ? 11 : parseInt(end[1]) - 1;
      var startMon = i === startYear ? parseInt(start[1]) - 1 : 0;
      for (var j = startMon; j <= endMonth; j = j > 12 ? j % 12 || 11 : j + 1) {
        var month = j + 1;
        var displayMonth = month < 10 ? "0" + month : month;
        dates.push([i, displayMonth, "01"].join("-"));
      }
    }
    setmonthlyFeeInputsvalue(dates);
  };

  const getMonthName = (date) => {
    const monthNames = [
      "January", // index 0
      "February", // index 1
      "March", // index 2
      "April", // index 3
      "May", // index 4
      "June", // index 5
      "July", // index 6
      "August", // index 7
      "September", // index 8
      "October", // index 9
      "November", // index 10
      "December", // index 11
    ];
    const d = new Date(date);

    return `${monthNames[d.getMonth()]}, ${d.getFullYear()}`;
  };

  return (
    <div>
      <Paper
        style={{ marginTop: "10px", marginBottom: "10px", padding: "15px" }}
      >
        {selectedSchoolIDs.length == 0 ? (
          <button
            onClick={() => alert.error("Please Select Some Schools")}
            className="btn btn-success button_blue"
          >
            Add Invoice
          </button>
        ) : (
          <button
            onClick={() => setPreviewModal(true)}
            className="btn btn-success button_blue"
          >
            Add Invoice
          </button>
        )}
        <br />
        <br />
        <GetAllSchoolInvoice
          getcurrentsession={setcurrentsession}
          getStudentArray={getStudentArray}
        />

        <Modal size="lg" show={previeweModal}>
          <Modal.Header className="modal_header_style" closeButton>
            <Modal.Title
              className="Modal_Heading_font"
              id="contained-modal-title-vcenter"
            >
              Generate Invoice
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <form class="form-card">
              <div class="row justify-content-between text-left">
                <div class="form-group flex-column d-flex pt-3">
                  <div>
                    <div class="form-group flex-column d-flex">
                      {/* <div class="flex-column d-flex"> */}
                      {/* <div class="switch ">
                          <label className="switchcheckboxlabel flex-row d-flex">
                            <input
                              onChange={() => {
                                setisMonthlyFee(!isMonthlyFee);
                              }}
                              defaultChecked={isMonthlyFee}
                              type="checkbox"
                            />
                            <span class="lever"></span>
                            <h3 className="switchcheckboxtext">Monthly Fee</h3>
                          </label>
                        </div> */}

                      {/* {isMonthlyFee ? ( */}
                      <div className="row">
                        <label class="form-control-label ml-2">
                          <b>
                            Invoice Months{" "}
                            <span style={{ color: "red" }}>*</span>
                          </b>
                        </label>
                        <div className="col-md-8 ">
                          <RangePicker
                            getPopupContainer={(triggerNode) => {
                              return triggerNode.parentNode;
                            }}
                            style={{ height: "40px" }}
                            picker="month"
                            onChange={(day, date) => handleChanger(day, date)}
                          />
                        </div>
                      </div>
                      {/* ) : null} */}
                      {/* </div> */}
                    </div>

                    {/* <div>
                      <div class="switch">
                        <label className="switchcheckboxlabel flex-row d-flex">
                          <input
                            onChange={() => {
                              setisAdditionalFee(!isAdditionalFee);
                              setadditiionalfeeinputs([1]);
                              setAmount([]);
                            }}
                            type="checkbox"
                            defaultChecked={isAdditionalFee}
                          />
                          <span class="lever"></span>
                          <h3 className="switchcheckboxtext">Additional Fee</h3>
                        </label>
                      </div>

                      {isAdditionalFee ? (
                        <div>
                          <div className="form-group column">
                            {additiionalfeeinputs.map((item, index) => (
                              <div className="col-lg-12 col-sm-12 mb-4">
                                <div className="row">
                                  <div className="col-md-4">
                                    <label class="form-control-label">
                                      <b>Add Additional Fee</b>{" "}
                                      <span style={{ color: "red" }}>*</span>
                                    </label>
                                    <select
                                      defaultValue={fees_type_id[index]}
                                      value={fees_type_id[index]}
                                      onChange={(e) => {
                                        let updatingarray = [...fees_type_id];
                                        updatingarray[index] = e.target.value;
                                        amount[index] = "";
                                        monthDate[
                                          index
                                        ] = getCurrentMonthYear();
                                        setfees_type_id(updatingarray);
                                      }}
                                      className="form-select h-40px"
                                      aria-label="Default select example"
                                    >
                                      <option selected disabled>
                                        Select Fee Type
                                      </option>
                                      {feetypes.map((fee) => (
                                        <option key={fee.id} value={fee.id}>
                                          {fee.name}
                                        </option>
                                      ))}
                                    </select>
                                  </div>

                                  <div className="col-md-3">
                                    <label class="form-control-label">
                                      <b>(Concession ignored)</b>{" "}
                                      <span style={{ color: "red" }}>*</span>
                                    </label>
                                    <input
                                      className="form-control"
                                      type="number"
                                      onChange={(e) => {
                                        additionalfeeChange(e, index);
                                      }}
                                      defaultValue={amount[index]}
                                      value={amount[index]}
                                      placeholder="Enter Custom Amount"
                                    />
                                  </div>

                                  <div className="col-md-4">
                                    <label class="form-control-label">
                                      <b>Fee Month</b>{" "}
                                      <span style={{ color: "red" }}>*</span>
                                    </label>
                                    <input
                                      defaultValue={getCurrentMonthYear()}
                                      value={monthDate[index]}
                                      className="form-control"
                                      onChange={(e) => {
                                        let updatingarray = [...monthDate];
                                        updatingarray[index] = e.target.value;
                                        setMonthDate(updatingarray);
                                      }}
                                      type="month"
                                    />
                                  </div>

                                  <div className="col-md-1 mt-10">
                                    <span
                                      className="svg-icon svg-icon-xl cursor-pointer"
                                      onClick={(e) => {
                                        e.preventDefault();

                                        setadditiionalfeeinputs(
                                          additiionalfeeinputs.filter(
                                            (item, i) => i !== index
                                          )
                                        );
                                        setfees_type_id(
                                          fees_type_id.filter(
                                            (item, i) => i !== index
                                          )
                                        );
                                        setAmount(
                                          amount.filter(
                                            (item, i) => i !== index
                                          )
                                        );
                                      }}
                                    >
                                      <IoMdCloseCircle
                                        color="#F64E60"
                                        height="25px"
                                        width="25px"
                                      />
                                    </span>
                                  </div>
                                </div>
                              </div>
                            ))}

                            <div className="col-lg-3 col-sm-12">
                              <button
                                id="add_additional_Fee_button"
                                onClick={(e) => {
                                  addAdditionalInputfield(e);
                                }}
                                className="btn btn-success button_blue"
                              >
                                Add Fields
                              </button>
                            </div>
                          </div>
                        </div>
                      ) : null}
                    </div> */}

                    <div class="form-group row">
                      {/* <div className="form-group col-md-4 flex-column d-flex mt-5">
                        <div className="switch">
                          <label className="switchcheckboxlabel flex-row d-flex">
                            <input
                              onChange={(e) => {
                                setIsFineEnable(e.target.checked);
                              }}
                              type="checkbox"
                              defaultChecked={isFineEnable}
                            />
                            <span class="lever"></span>
                            <h3 className="switchcheckboxtext">Add Fine</h3>
                          </label>
                        </div>
                      </div> */}
                      <div className="col-md-6">
                        <label class="form-control-label">
                          <b>
                            Due Date <span style={{ color: "red" }}>*</span>
                          </b>
                        </label>
                        <input
                          format="DD/MM/YYYY"
                          max="9999-12-30"
                          onChange={(e) => setdue_date(e.target.value)}
                          type="date"
                          value={due_date}
                          class="form-control  mb-2"
                        />
                      </div>

                      <div className="col-md-6">
                        <label class="form-control-label">
                          <b>
                            Issue Date <span style={{ color: "red" }}>*</span>
                          </b>
                        </label>
                        <input
                          format="DD/MM/YYYY"
                          max="9999-12-30"
                          value={issue_date}
                          onChange={(e) => setissue_date(e.target.value)}
                          type="date"
                          class="form-control  mb-2"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
            {isallfields ? (
              <>
                <Alert
                  variant="danger"
                  onClose={() => setisallfields(false)}
                  dismissible
                >
                  <Alert.Heading>Oh snap! You got an error!</Alert.Heading>
                  <p>{errorcreate}</p>
                </Alert>
              </>
            ) : null}
          </Modal.Body>
          {preInvoiceLoading ? (
            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "flex-end",
                padding: "15px",
              }}
            >
              {" "}
              <span className="spinner-border"></span>{" "}
            </div>
          ) : (
            <Modal.Footer>
              <button
                onClick={previewSchoolInvoice}
                className="btn btn-success button_blue"
              >
                Preview
              </button>

              <button
                onClick={() => {
                  cencelModal();
                  setPreviewModal(false);
                }}
                className="btn btn-danger btn_width"
              >
                Cancel
              </button>
            </Modal.Footer>
          )}
        </Modal>

        <Modal size="lg" show={invoiceModal}>
          <Modal.Header className="modal_header_style" closeButton>
            <Modal.Title
              className="Modal_Heading_font"
              id="contained-modal-title-vcenter"
            >
              Previw Invoice Detail
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div
              className="table-responsive"
              style={{ maxHeight: "500px", overflowY: "auto" }}
            >
              <Table className="mt-2">
                <thead className="text-center">
                  <th>Invoice No.</th>
                  <th>School Account</th>
                  <th>Month</th>
                  <th>Due Date</th>
                  <th>Issue Date</th>
                  <th>Royalty Amount</th>
                </thead>
                <tbody>
                  {Array.isArray(invoiceData?.created) &&
                    invoiceData?.created &&
                    invoiceData?.created.map((school, index) => (
                      <tr key={index} className="text-center">
                        <td>{school?.invoice_number}</td>
                        <td>
                          {school?.school_account?.school_name ??
                            school?.school_account_id}
                        </td>
                        <td>{getMonthName(school?.month)}</td>
                        <td>{school?.due_date}</td>
                        <td>{school?.issue_date}</td>
                        <td>
                          {Intl.NumberFormat("en-Us").format(school?.payable)}
                        </td>
                      </tr>
                    ))}
                  <tr>
                    <td colSpan={4} className="text-end">
                      <b>Total Amount:</b>
                    </td>
                    <td colSpan={2} className="text-center">
                      <b>
                        {Intl.NumberFormat("en-Us").format(
                          invoiceData?.total_amount
                        )}
                      </b>
                    </td>
                  </tr>
                </tbody>
              </Table>
            </div>
          </Modal.Body>
          {invoiceLoading ? (
            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "flex-end",
                padding: "15px",
              }}
            >
              {" "}
              <span className="spinner-border"></span>{" "}
            </div>
          ) : (
            <Modal.Footer>
              <button
                onClick={generateSchoolInvoice}
                className="btn btn-success button_blue"
              >
                Generate
              </button>

              <button
                onClick={() => {
                  cencelModal();
                  setInvoiceModal(false);
                }}
                className="btn btn-danger btn_width"
              >
                Cancel
              </button>
            </Modal.Footer>
          )}
        </Modal>
      </Paper>
    </div>
  );
}

export default GenerateInvoice;
